"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const splide_1 = require("@splidejs/splide");
const splideInstances = new WeakMap();
const initialisedReadMore = new WeakMap();
let currentPage = 1;
/**
 * Handle the click on the read more button
 */
const readMoreToggle = (card, readMoreEle) => {
    var _a;
    card.classList.toggle('card-open');
    readMoreEle.innerText = card.classList.contains('card-open') ? 'Read Less' : 'Read More';
    (_a = splideInstances.get(card)) === null || _a === void 0 ? void 0 : _a.refresh();
};
/**
 * Handle the click on the load more button
 */
const loadMoreHandler = (event) => __awaiter(void 0, void 0, void 0, function* () {
    const button = event.currentTarget;
    const grid = document.querySelector('.coworking-listing__grid');
    const ajaxUrl = button.dataset.ajaxUrl;
    if (!grid || !ajaxUrl)
        return;
    button.disabled = true;
    try {
        const formData = new FormData();
        formData.append('action', 'load_more_coworking');
        formData.append('page', String(++currentPage));
        const response = yield fetch(ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        const data = yield response.json();
        if (data.success) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.html;
            while (tempDiv.firstChild) {
                grid.insertBefore(tempDiv.firstChild, button);
            }
            registerCoWorkingEvents();
            if (!data.hasMore)
                button.remove();
        }
    }
    catch (error) {
        console.error('Error loading more posts:', error);
    }
    finally {
        button.disabled = false;
    }
});
/**
 * Initialise read more functionality for a card
 */
const initialiseReadMore = (card, readMoreEle) => {
    if (!initialisedReadMore.has(card)) {
        readMoreEle.addEventListener('click', () => readMoreToggle(card, readMoreEle));
        initialisedReadMore.set(card, true);
    }
};
/**
 * Initialise Splide carousel for a card
 */
const initialiseSplide = (card, cardGallery, previewImages) => {
    if (!splideInstances.has(card)) {
        const splide = new splide_1.Splide(cardGallery, {
            perPage: 1,
            type: 'loop',
            pagination: false,
            arrows: true,
        });
        splide.mount();
        splideInstances.set(card, splide);
        for (let i = 0; i < previewImages.length; i++) {
            previewImages[i].addEventListener('click', () => splide.go(i));
        }
    }
};
/**
 * Register CoWorking Listing click on the read more button
 */
const registerCoWorkingEvents = () => {
    const cards = document.querySelectorAll('.coworking-listing__card');
    for (const card of cards) {
        const readMoreEle = card.querySelector('.coworking-listing__read-more');
        const cardGallery = card.querySelector('.coworking-listing__card-gallery');
        const previewImages = card.querySelectorAll('.coworking-listing__preview-item');
        if (readMoreEle) {
            initialiseReadMore(card, readMoreEle);
        }
        if (cardGallery) {
            initialiseSplide(card, cardGallery, previewImages);
        }
    }
};
/**
 * Initialise CoWorking Listing
 */
const initCoWorkingListing = () => {
    const loadMoreButton = document.querySelector('[data-cowoking-load-more]');
    registerCoWorkingEvents();
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', loadMoreHandler);
    }
};
exports.default = initCoWorkingListing;
